import { ShieldCheck, Info } from "lucide-react";
import { LegalModal } from "@/components/landing/Legal";

const POINTS = [
  "No sustituye al odontólogo.",
  "No toma decisiones clínicas.",
  "No modifica diagnósticos ni tratamientos.",
  "No sustituye el software clínico.",
  "Ayuda a automatizar confirmaciones y tareas administrativas.",
  "Escala a recepción cuando una situación requiere intervención humana.",
  "Permite revisar y configurar las reglas de comunicación.",
];

export default function Security() {
  return (
    <section id="seguridad" className="bg-platinum py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="text-sm font-semibold uppercase tracking-widest text-navy-light">
              Seguridad y proceso clínico
            </p>
            <h2
              data-testid="security-title"
              className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-navy sm:text-4xl lg:leading-[1.15]"
            >
              La IA trabaja alrededor de tu clínica, no en lugar de tu equipo.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-steel sm:text-lg">
              DentalAi automatiza la parte administrativa de las confirmaciones y las
              cancelaciones. Las decisiones clínicas y el trato con el paciente siguen en
              manos de tu equipo.
            </p>
            <div className="mt-6 flex items-start gap-2 rounded-xl border border-[#E4E9F2] bg-white p-4 text-xs leading-relaxed text-steel">
              <Info className="mt-0.5 h-4 w-4 shrink-0 text-navy-light" />
              <p>
                Tratamos los datos con prudencia y conforme a la normativa de protección
                de datos. Consulta nuestra{" "}
                <LegalModal
                  type="privacidad"
                  testId="security-privacy-link"
                  trigger={
                    <button
                      type="button"
                      className="font-semibold text-navy underline decoration-navy/30 underline-offset-2 hover:decoration-navy"
                    >
                      política de privacidad
                    </button>
                  }
                />
                . La clínica debe revisar sus obligaciones legales y contractuales antes
                de activar cada canal de comunicación.
              </p>
            </div>
          </div>

          <ul className="space-y-3">
            {POINTS.map((point, i) => (
              <li
                key={point}
                data-testid={`security-point-${i + 1}`}
                className="flex items-start gap-3 rounded-xl border border-[#E8EDF5] bg-white p-4 shadow-sm"
              >
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#E7F4EC]">
                  <ShieldCheck className="h-3.5 w-3.5 text-recover" strokeWidth={2.2} />
                </span>
                <span className="text-sm font-medium leading-relaxed text-navy">{point}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
